import { inject, Injectable } from '@angular/core';
import Keycloak from 'keycloak-js';

/**
 * Keycloak-Realm-Rollen des Admin-Portals (siehe cnf-keycloak-infrastructure, role.tf).
 * Das Backend prueft dieselben Rollen; das UI blendet Menues und Aktionen ohne Rolle aus.
 */
export const Role = {
    Access: 'CanAccess',
    BaseAccessDashboard: 'CanBaseAccessDashboard',
    BaseAccessMember: 'CanBaseAccessMember',
    BaseAccessFinance: 'CanBaseAccessFinance',
    BaseAccessJob: 'CanBaseAccessJob',
    ReadAllJobs: 'CanReadAllJobs',
    DeleteJobDocument: 'CanDeleteJobDocument',
    RestartJob: 'CanRestartJob',
    ProcessModification: 'CanProcessModification',
    CreateMember: 'CanCreateMember',
    EditMember: 'CanEditMember',
    DeleteMemberData: 'CanDeleteMemberData',
    ExportMember: 'CanExportMember',
    ExportMemberOverview: 'CanExportMemberOverview',
    AcceptMembership: 'CanAcceptMembership',
    EditMemberAddress: 'CanEditMemberAddress',
    ProcessMemberCard: 'CanProcessMemberCard',
    SendInvoiceMail: 'CanSendInvoiceMail',
    ProcessMemberExit: 'CanProcessMemberExit',
    ProcessMemberReenter: 'CanProcessMemberReenter',
    ProcessMemberDeath: 'CanProcessMemberDeath',
    ProcessMemberDivorce: 'CanProcessMemberDivorce',
    ProcessMemberMarriage: 'CanProcessMemberMarriage',
    EditInvoice: 'CanEditInvoice',
    AcceptInvoice: 'CanAcceptInvoice',
    DeleteInvoice: 'CanDeleteInvoice',
    DeleteInvoiceWithReminders: 'CanDeleteInvoiceWithReminders',
    PostponeInvoice: 'CanPostponeInvoice',
    SettleDebitor: 'CanSettleDebitor',
    ProcessInvoiceRun: 'CanProcessInvoiceRun',
    ProcessBankImport: 'CanProcessBankImport',
    EditContributionYear: 'CanEditContributionYear'
} as const;

export type RoleName = (typeof Role)[keyof typeof Role];

@Injectable({
    providedIn: 'root'
})
export class RoleService {
    private readonly keycloak = inject(Keycloak);

    /** Das Backend wertet nur Realm-Rollen aus, daher auch hier nur diese. */
    hasRole(role: RoleName): boolean {
        return this.keycloak.realmAccess?.roles?.includes(role) ?? false;
    }

    hasAnyRole(roles: readonly RoleName[]): boolean {
        return roles.some((role) => this.hasRole(role));
    }

    hasAllRoles(roles: readonly RoleName[]): boolean {
        return roles.every((role) => this.hasRole(role));
    }
}
